/* eslint-disable */
import createIcon from '../createIcon';

const IconHomeOutlined = createIcon({
  name: 'icon-home-outlined',
  content: '<path d="M512.955818 212.828874l318.606099 265.080273V828.375856h-637.212197V477.909147l318.606098-265.080273m0-82.837586l-382.327318 318.606098v446.048538h764.654636V446.048538l-382.327318-318.606099z"/><path d="M544.816428 512.318606h-63.72122v191.163659h63.72122v-191.163659z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconHomeOutlined;
